var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Grid } from "react-bootstrap";
import RewardsLanesQuery from "@irati/reward/apollo/query/HomePageRewardsLanes";
import FeedSlider from "@irati-web/reward/src/components/FeedSlider";
import { NoResults } from "@irati-web/reward/src/components/List";
import { RewardSuccessPopup } from "@irati-web/reward/src/components/Success";
import { rewardTracking } from "@irati-tracking/reward";
import RewardBanner from "@irati-web/reward/src/components/Banner";
import Layout from "@irati-web/recognition/src/components/Layout";
import bannerImg from "@irati-web/recognition/src/images/banner.png";
import RewardService from "@irati/reward/apollo/Reward";
var RecognitionRewards = /** @class */ (function (_super) {
    __extends(RecognitionRewards, _super);
    function RecognitionRewards() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.handleClearOrder = function () {
            _this.setState({
                rewardOrder: undefined
            });
        };
        return _this;
    }
    RecognitionRewards.prototype.componentDidMount = function () {
        var _this = this;
        var uuid = this.props.match.params.uuid;
        if (uuid) {
            RewardService.getRewardOrder(uuid).then(function (rewardOrder) {
                _this.setState({ rewardOrder: rewardOrder });
            });
        }
        rewardTracking.rewardsTabHome();
    };
    RecognitionRewards.prototype.render = function () {
        var rewardOrder = this.state.rewardOrder;
        return (React.createElement(Layout, { bannerImg: bannerImg, bannerChild: React.createElement(RewardBanner, null) },
            React.createElement(Grid, null,
                React.createElement(RewardsLanesQuery, null, function (_a) {
                    var lanes = _a.data.homePageRewardsLanes;
                    if (!lanes.length) {
                        return React.createElement(NoResults, null);
                    }
                    return lanes.map(function (lane, index) { return (React.createElement(FeedSlider, { isFirst: index === 0, key: index, id: "reward-slider-" + index, title: lane.tags.map(function (tag) { return tag.name; }).join(" & "), data: lane.rewards })); });
                })),
            rewardOrder && React.createElement(RewardSuccessPopup, { rewardOrder: rewardOrder, redirectToFeed: true, onAfterExitModal: this.handleClearOrder })));
    };
    return RecognitionRewards;
}(Component));
export default RecognitionRewards;
